// extracted by mini-css-extract-plugin
export default {"page-wrapper":"PageWrapper_page-wrapper__ExvmX","hidden":"PageWrapper_hidden__OhnpN","footer":"PageWrapper_footer__Gv3jn"};